/*
 * AboutPage
 *
 * This is the first thing users see of our App, at the '/' route
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Footer } from '../../features/footer/Footer';
import { Header } from '../../features/header/Header';
import { withAuthentication } from '../../common/authentication';
import { withRouter } from 'react-router-dom';
import { Container, Col } from 'reactstrap';
import { injectIntl, FormattedMessage } from 'react-intl';
import messages from './messages';

function AboutPage({ intl }) {
  return (
    <>
      <Helmet>
        <title>PARAMETA Solutions Trading Analytics - About Us</title>
        <meta name="description" content="Description of About Page" />
      </Helmet>
      <Header />
      <Container>
        <h1 className="py-4">
          <FormattedMessage {...messages.header} />
        </h1>
        <p className="py-4">
          <FormattedMessage {...messages.aboutDescription} />
        </p>
        <p className="py-2">
          <FormattedMessage
            {...{
              ...messages.aboutCall,
              values: {
                contactLink: (
                  <a
                    href={`mailto:${intl.formatMessage(messages.contactEmail)}`}
                  >
                    <FormattedMessage {...messages.contactEmail} />
                  </a>
                ),
              },
            }}
          />
        </p>
        <h2>Locations</h2>
        <Col className="mb-5">
          <h3>New York</h3>
          <p>
            200 Vesey Street
            <br />
            5th Floor
            <br />
            New York, NY
            <br />
            United States
            <br />
          </p>
          <h3>Singapore</h3>
          <p>
            50 Raffles Place
            <br />
            #41-00 Singapore Land Tower
            <br />
            Singapore 048623
            <br />
          </p>
          <h3>London</h3>
          <p>
            Floor 2,
            <br />
            155 Bishopsgate
            <br />
            Spitalfields
            <br />
            London
            <br />
            EC2M 3TQ
            <br />
          </p>
        </Col>
      </Container>
      <Footer />
    </>
  );
}

AboutPage.propTypes = {
  authState: PropTypes.object,
  authService: PropTypes.object,
  global: PropTypes.object,
  intl: PropTypes.object,
};

export default withRouter(withAuthentication(injectIntl(AboutPage)));
